// Show date in DD/MM/YYYY format
export const dateDDMMYYYY = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  return `${day}/${month}/${year}`
}

export const isoDateToDDMM = (isoDate: string): string => {
  const [, month, day] = isoDate.split('-')
  return `${day}/${month}`
}

export const formatPlanningWeekLabel = ({
  weekNumber,
  year,
  dateStart,
  dateEnd,
}: {
  weekNumber: number
  year: number
  dateStart: string
  dateEnd: string
}): string =>
  `S${String(weekNumber).padStart(2, '0')} ${year} (${isoDateToDDMM(dateStart)} au ${isoDateToDDMM(dateEnd)})`

/** `YYYY-MM-DD` → `DD/MM/YYYY`, sans passer par une date (aucun fuseau en jeu). */
export const isoDateToDDMMYYYY = (isoDate: string): string => {
  const [year, month, day] = isoDate.slice(0, 10).split('-')
  return `${day}/${month}/${year}`
}

const pad = (value: number, length: number): string => String(value).padStart(length, '0')

/** Année ISO 8601 : quatre chiffres, six avec signe hors de 0..9999 (comme Luxon). */
const isoYear = (year: number): string =>
  year >= 0 && year <= 9999 ? pad(year, 4) : `${year < 0 ? '-' : '+'}${pad(Math.abs(year), 6)}`

/**
 * `YYYY-MM-DD` d'une valeur de date, `null` conservé :
 * - `Date` → jour civil dans le fuseau du process (celui de `DateTime.fromJSDate(d).toISODate()`
 *   sans `Settings.defaultZone`), `null` pour une date invalide ;
 * - autre valeur (colonne `date` déjà sérialisée, ISO complet) → ses dix premiers caractères.
 */
export const toIsoDate = (value: unknown): string | null => {
  if (value === null || value === undefined) return null
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null
    return `${isoYear(value.getFullYear())}-${pad(value.getMonth() + 1, 2)}-${pad(value.getDate(), 2)}`
  }
  return String(value).slice(0, 10)
}

/**
 * Date validée par VineJS (`DateTime` de Luxon, cf. `start/validator.ts`) → `YYYY-MM-DD` du fuseau
 * du process. Typée sur `toJSDate` pour que `@gozoki/tools` reste sans dépendance.
 */
export const adonisDateToIsoDate = (date: { toJSDate: () => Date }): string =>
  toIsoDate(date.toJSDate()) ?? ''
